// Utility for sessionStorage operations

const session = {
  set(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  },
  get(key) {
    try {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  },
  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }
};

export default session;
